gsap.set(".co-acne-1", { opacity: 0 });
    gsap.to(".co-acne-1", {
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut"
    });
    gsap.to(".co-acne-1-blob-2", {
        scrollTrigger: {
        trigger: ".co-acne-1",
        start: "top top",
        end: "bottom top",
        scrub: true
      },
      x: -80,
      y: 140,
      rotateZ: "20deg"
    });
    gsap.to(".co-acne-1-blob-1>div", {
        scrollTrigger: {
        trigger: ".co-acne-1",
        start: "top top",
        end: "bottom top",
        scrub: true
      },
      x: 60,
      y: -100,
      rotateZ: "-30deg"
    });
    // 2
    gsap.set(".co-acne-2-top-image", { opacity: 0, y: 20 });
    gsap.to(".co-acne-2-top-image", {
        scrollTrigger: {
        trigger: ".co-acne-2-top-image",
        start: "top 90%",
        end: "bottom top",
      },
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut"
    });
    gsap.set(".co-acne-2-ani", { opacity: 0, y: 20 });
    gsap.to(".co-acne-2-ani", {
        scrollTrigger: {
        trigger: ".co-acne-2-top-left-frame",
        start: "top 90%",
        end: "bottom top",
      },
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut",
      stagger: 0.1
    });
    gsap.to(".co-acne-2-top-image>div", {
      scrollTrigger: {
        trigger: ".co-acne-2-top-image",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      top: "-10%"
    });
    // 3
    gsap.set(".co-acne-2-bottom-image", { opacity: 0, y: 20 });
    gsap.to(".co-acne-2-bottom-image", {
        scrollTrigger: {
        trigger: ".co-acne-2-bottom-image",
        start: "top 90%",
        end: "bottom top",
      },
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut"
    });
    gsap.set(".co-acne-2-ani-bot", { opacity: 0, y: 20 });
    gsap.to(".co-acne-2-ani-bot", {
        scrollTrigger: {
        trigger: ".co-acne-2-bottom-left-frame",
        start: "top 90%",
        end: "bottom top",
      },
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut",
      stagger: 0.1
    });
    gsap.to(".co-acne-2-bottom-image>div", {
      scrollTrigger: {
        trigger: ".co-acne-2-bottom-image",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      top: "-10%"
    });
    // pin
    (function () {
  gsap.registerPlugin(ScrollTrigger);

  let st = null;

  function initDynamicPin(selector = ".co-acne-2-top") {
    const el = document.querySelector(selector);
    if (!el) return;

    function createDynamicPin() {
      if (st) st.kill();

      const isTallerThanViewport = el.offsetHeight > window.innerHeight;

      st = ScrollTrigger.create({
        trigger: el,
        start: isTallerThanViewport ? "bottom bottom" : "top top",
        end: "bottom top",
        pin: true,
        pinSpacing: false
      });
    }

    createDynamicPin();

    ScrollTrigger.addEventListener("refreshInit", createDynamicPin);
    ScrollTrigger.refresh();
  }

  // Auto-init
  initDynamicPin();
})();

    // 3
    gsap.to(".co-acne-3-blob-1-frame>div", {
        scrollTrigger: {
        trigger: ".co-acne-3",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -50,
      x: -50,
      rotateZ: "-10"
    });
    gsap.set(".co-acne-3", { opacity: 0 });
    gsap.to(".co-acne-3", {
        scrollTrigger: {
        trigger: ".co-acne-3-tabs-navigation",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut"
    }); 
    gsap.set(".co-acne-3-tabs-button>div", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-3-tabs-button>div", {
        scrollTrigger: {
        trigger: ".co-acne-3-tabs-navigation",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut",
      stagger: 0.2
    });
    // 4
    gsap.to(".co-acne-4-blob-1-frame", {
        scrollTrigger: {
        trigger: ".co-acne-4",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -50,
      x: 50,
      rotateZ: "10"
    });
    gsap.set(".co-acne-4-left", { x: -30, transition: "0s" });
    gsap.to(".co-acne-4-left", {
        scrollTrigger: {
        trigger: ".co-acne-4-left",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      x: 0,
      duration: 0.75,
      ease: "Power4.inOut"
    });
    gsap.set(".co-acne-4-right", { opacity: 0, x: 30, transition: "0s" });
    gsap.to(".co-acne-4-right", {
        scrollTrigger: {
        trigger: ".co-acne-4-right",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      x: 0,
      duration: 0.75,
      ease: "Power4.inOut"
    });
    // 5
    gsap.to(".co-acne-5-blob-1-frame", {
        scrollTrigger: {
        trigger: ".co-acne-5",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -50,
      x: -50,
      rotateZ: "-10"
    });
    gsap.set(".co-acne-5-frame", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-5-frame", {
        scrollTrigger: {
        trigger: ".co-acne-5-frame",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut"
    });
    // 6
    gsap.to(".co-acne-6-blob-1-frame", {
        scrollTrigger: {
        trigger: ".co-acne-6",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -75,
      x: -50,
      rotateZ: "10"
    });
    gsap.to(".co-acne-6-blob-2-frame", {
        scrollTrigger: {
        trigger: ".co-acne-6",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -75,
      x: 30,
      rotateZ: "-10"
    });
    gsap.to(".co-acne-6-blob-3-frame", {
        scrollTrigger: {
        trigger: ".co-acne-6",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -105,
      x: -30,
      rotateZ: "10"
    });
    gsap.to(".co-acne-6-blob-4-frame", {
        scrollTrigger: {
        trigger: ".co-acne-6",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: 45,
      x: 50,
      rotateZ: "-10"
    });
    gsap.set(".co-acne-6-content", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-6-content", {
        scrollTrigger: {
        trigger: ".co-acne-6-content",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut"
    });
    // 7
    gsap.set(".co-acne-7-content", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-7-content", {
        scrollTrigger: {
        trigger: ".co-acne-7-content",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut"
    });
    gsap.to(".co-acne-7-right-image", {
        scrollTrigger: {
        trigger: ".co-acne-7-right",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      top: "5%"
    });
    gsap.to(".co-acne-8-blob-1-frame", {
        scrollTrigger: {
        trigger: ".co-acne-8-blob-1",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: 45,
      x: 50,
      rotateZ: "-10"
    });
    gsap.to(".co-acne-8-blob-2-frame", {
        scrollTrigger: {
        trigger: ".co-acne-8-blob-2",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: 45,
      x: -70,
      rotateZ: "10"
    });
    gsap.set(".co-acne-8-ani", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-8-ani", {
        scrollTrigger: {
        trigger: ".co-acne-8-content",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut",
      stagger: 0.2
    });